export const filterNonEmptyItems = (array: any) => {
  return array.filter((value: any) => {
    if (value) {
      return value;
    }
  });
};
export const pluck = (array: any[], key: any) => {
  const validArray = filterNonEmptyItems(array);
  if (validArray && validArray.length > 0) {
    return validArray.map((item: any) => item[key]);
    // return filterNonEmptyItems(mappedList);
  }
  return [];
};
export const isObject = (value: unknown): value is object => {
  return value !== null && typeof value === 'object';
};
export const isNullOrEmptyObject = (obj: any): boolean => {
  return obj === null || (typeof obj === 'object' && Object.keys(obj).length === 0);
};
export const isDifferentJSON = (json1: any, json2: any) => {
  // Get keys from both JSON objects
  const keys1 = Object.keys(json1);
  const keys2 = Object.keys(json2);

  // If the number of keys is different, the objects are not equal
  if (keys1.length !== keys2.length) {
    return true;
  }

  // Iterate over keys and compare values
  for (const key of keys1) {
    // If the keys don't match, objects are not equal
    if (!keys2.includes(key)) {
      return true;
    }

    // If the values for the keys don't match, objects are not equal
    if (JSON.stringify(json1[key]) !== JSON.stringify(json2[key])) {
      return true;
    }
  }

  // If all checks pass, objects are equal
  return false;
};
export const cleanObject = (
  data: Record<string, any>,
  options?: {
    removeKeys?: string[];
    removeEmptyString?: boolean;
    removeNull?: boolean;
    removeUndefined?: boolean;
  }
) => {
  const {
    removeKeys = [],
    removeEmptyString = true,
    removeNull = true,
    removeUndefined = true,
  } = options || {};

  return Object.fromEntries(
    Object.entries(data).filter(([key, value]) => {
      if (removeKeys.includes(key)) return false;
      if (removeEmptyString && value === '') return false;
      if (removeNull && value === null) return false;
      if (removeUndefined && value === undefined) return false;

      return true;
    })
  );
};
